// src/components/common/VersionFooter.tsx
import React from 'react';
import './VersionFooter.css';

const VersionFooter: React.FC = () => {
  // Get version from environment variable (injected at build time)
  const version = process.env.REACT_APP_VERSION || 'dev';
  const isDev = version === 'dev';

  return (
    <div className="version-footer">
      <span className="version-text">
        {isDev ? (
          <>
            <span className="version-label">Development Mode</span>
            <span className="version-number">{version}</span>
          </>
        ) : (
          <>
            <span className="version-label">Version</span>
            <span className="version-number">{version}</span>
          </>
        )}
      </span>
    </div>
  );
};

export default VersionFooter;
